import { Gltf } from '../gltf';
import { readAnimationStateExtras } from '../gltf/AnimationStateExtras';
import { RenderObject } from '../object/RenderObject';
import { AnimationState } from './AnimationState';
import { EntityAnimationState } from './EntityAnimationState';

export function createAnimationState(object: RenderObject, json: Gltf): AnimationState {
  const extras = readAnimationStateExtras(json);

  if (extras) {
    switch (extras.type) {
      case 'Entity':
        return new EntityAnimationState(object, extras.stateMapping);
    }
  }

  // Backward compatibility: build identity mapping from glTF animation names
  const state = new AnimationState(object);
  const animations = json.animations ?? [];
  const allowed: Record<string, { repeat: string; speed: number }> = {};
  for (let i = 0; i < animations.length; i++) {
    const id = animations[i].name || `Anim${i}`;
    allowed[id] = { repeat: 'always', speed: 1.0 };
  }
  state.allowedStates = allowed;
  return state;
}
